import type { ReactNode } from 'react';
import { Alert, Center, Stack, Text } from '@mantine/core';
import { IconBriefcase } from '@tabler/icons-react';
import { useProjectStore } from './project-store';

export function RequireProject({ children }: { children: ReactNode }) {
  const projectId = useProjectStore((s) => s.projectId);
  if (!projectId) {
    return (
      <Center h="60vh">
        <Stack gap="sm" align="center" maw={420}>
          <Alert variant="light" color="pine" icon={<IconBriefcase />} title="Pick a project">
            <Text size="sm">
              Use the selector in the top bar to choose a project. All tracts, title runs, and other
              data are scoped to the active project.
            </Text>
          </Alert>
        </Stack>
      </Center>
    );
  }
  return <>{children}</>;
}
